import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";

export interface TrendGraphProps
{
    styles: Record<string, string>;
    values: number[];
    width: number;
    height: number;
    minTarget?: number;
    maxTarget?: number;
    showPoints?: boolean;
    targetWidth: number;
}

export interface TrendGraphState
{
}

const useStyles = makeStyles(
    {
    });

export class TrendGraphWithoutStyles extends React.Component<TrendGraphProps, TrendGraphState>
{
    adjustY(point: number, height: number, scaleY: number, maxValue: number, minTarget?: number, maxTarget?: number): number
    {
        return (minTarget !== undefined && maxTarget !== undefined)
            ? height - ((point - minTarget) * height) / (maxTarget - minTarget)
            : (maxValue - point) * scaleY;
    }

    render()
    {
        const width = this.props.width;
        const height = this.props.height;
        const data = this.props.values;

        const minValue = Math.min(...data);
        const maxValue = Math.max(...data);

        // Calculate the scaling factor for the y-axis
        const scaleY = height / (maxValue - minValue);

        // Calculate the spacing between each data point along the x-axis
        const scaleX = width / (data.length - 1);

        console.log(`width: ${width}, data.length: ${data.length}, targetWidth: ${this.props.targetWidth}, scaleX: ${scaleX}`)
        // Generate the path for the line chart
        const path = data
            .map(
                (point, index) =>
                {
                    const x = index * scaleX;
                    const y = this.adjustY(point, height, scaleY, maxValue, this.props.minTarget, this.props.maxTarget);

                    const yCheck = (this.props.minTarget !== undefined && this.props.maxTarget !== undefined)
                                       ? height - ((point - this.props.minTarget) * height) / (this.props.maxTarget - this.props.minTarget)
                                       : (maxValue - point) * scaleY; // Invert y to align with SVG coordinate system

                    return `${index === 0 ? 'M' : 'L'} ${x},${y}`;
                })
            .join(' ');

        const widthPct = `${this.props.targetWidth}%`;

        //<svg width={width} height={height}>
        return (
            <svg>
                <path d={path} fill="none" stroke="black" strokeWidth="2.5"/>
                { /* Optional: Render points */
                }
                {this.props.showPoints
                    && data.map(
                        (point, index) =>
                        {
                            const x = index * scaleX;
                            const y = this.adjustY(point, height, scaleY, maxValue, this.props.minTarget, this.props.maxTarget);

                            return <circle key={index} cx={x} cy={y} r="3" fill="blue"/>;
                        })}
            </svg>
        );
    }
}

export const TrendGraph = withStyles(useStyles, TrendGraphWithoutStyles);